import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Footer from '../Footer/Footer';

function About(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (1 === !1) return <Redirect to="/" />;
  return (
    <div>
      <div className="bg-light" style={{ marginBottom: '0px' }}>
        <div
          className="container py-5"
          style={{ marginTop: '3.4em', marginBottom: '0px' }}
        >
          <div className="row h-100 align-items-center py-5">
            <div className="col-lg-6">
              <h1 className="display-4">About Grospick</h1>
              <p
                className="lead text-dark mb-0"
                style={{ textAlign: 'justify' }}
              >
                We are a delivery company with a personal touch offering a huge
                range of services and locations convenient to you. Looking for
                reliable, cost effective and affordable delivery company? We are
                the solution, we can provide you with the best on time delivery
                service. We deliver anything from bread to fruits or even
                groceries, door to door and on-demand.
                <footer class="blockquote-footer">
                  {' '}
                  Don't step out, just{' '}
                  <cite title="Source Title">Grospick</cite> it
                </footer>
              </p>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img
                src="./img/logo_img/aboutt.png"
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white py-5">
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 order-2 order-lg-1">
              <i
                className="fa fa-cart-plus fa-2x mb-3"
                style={{ color: '#34918c' }}
              ></i>
              <h2 className="font-weight-bold">
                Delivery that leaves the IMPACT.
              </h2>
              <p className=" text-dark mb-4" style={{ textAlign: 'left' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Life is too short to waste it in
                finding the product you need from thousands of products in your
                Favorite supermarket, just click the photo of the product you
                need and get it to deliver with Grospick
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Our trained shoppers will shop for
                you in the grocery store and deliver to your home at the exact
                same price as the stores. Want to eat at your favorite
                restaurant, but they don't deliver? We will pick up your food
                and deliver it in minutes. This is a new way of life. The very
                best in your city, delivered in minutes. .
              </p>
              <Link
                to="./contact"
                style={{ textDecoration: 'none', color: '#34918c' }}
              >
                <a
                  className="btn btn-light px-5 rounded-pill shadow-sm"
                  href="//#endregion"
                >
                  Learn More
                </a>
              </Link>
            </div>
            <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/about2.png"
                alt=""
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 px-5 mx-auto">
              <img
                src="./img/about1.png"
                alt=""
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-6">
              <i
                className="fa fa-shopping-basket fa-2x mb-3"
                style={{ color: '#34918c' }}
              ></i>
              <h2 className="font-weight-bold">Ideal for FOODIES: </h2>
              <p className="text-dark mb-4">
                If you appreciate great food, you no longer have to order from
                the same 10 restaurants that offer fast delivery. Now, you can
                order from ANY restaurant in your city because we will order and
                deliver on your behalf. .
              </p>
              <Link
                to="./contact"
                style={{ textDecoration: 'none', color: '#34918c' }}
              >
                <a
                  className="btn btn-light px-5 rounded-pill shadow-sm"
                  href="//#endregion"
                >
                  Learn More
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light py-5">
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 order-2 order-lg-1">
              <i
                className="fa fa-users fa-2x mb-3"
                style={{ color: '#34918c' }}
              ></i>
              <h2 className="font-weight-bold">Ideal for BUSY PEOPLE: .</h2>
              <p className="text-dark mb-4" style={{ textAlign: 'left' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Life is too short to waste it in
                finding the product you need from thousands of products in your
                Favorite supermarket, just click the photo of the product you
                need and get it to deliver with Grospick
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;You no longer have to spend 3
                hours going to the grocery store every two weeks. Save the trip
                to the grocery store for a very special occasion, or for when
                you are looking for that special cheese. Leave the rest to
                Grospick. Program an order. Save time and money.{' '}
              </p>
              <Link
                to="./contact"
                style={{ textDecoration: 'none', color: '#34918c' }}
              >
                <a
                  className="btn btn-light px-5 rounded-pill shadow-sm"
                  href="//#endregion"
                >
                  Learn More
                </a>
              </Link>
            </div>
            <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2">
              <img
                src="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg"
                alt=""
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 px-5 mx-auto">
              <img
                src="https://res.cloudinary.com/mhmd/image/upload/v1556834136/img-2_vdgqgn.jpg"
                alt=""
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-6">
              <i
                className="fa fa-handshake-o fa-2x mb-3"
                style={{ color: '#34918c' }}
              ></i>
              <h2 className="font-weight-bold">Ideal for the GOOD LIFE: </h2>
              <p className="font-italic text-dark mb-4">
                With Grospick, everyone has a personal assistant that can do
                anything: from picking up medicine and bringing forgotten keys
                to paying invoices. When it comes to any errand you don't like
                to do, we are here to take care of you..
              </p>
              <Link
                to="./contact"
                style={{ textDecoration: 'none', color: '#34918c' }}
              >
                {' '}
                <a
                  className="btn btn-light px-5 rounded-pill shadow-sm"
                  href="//#endregion"
                >
                  Learn More
                </a>
              </Link>
            </div>
          </div>
        </div>
        <br /> <br />
      </div>
      <Footer />
    </div>
  );
}

export default About;
